import React, { useState } from 'react';
import { CheckCircle2, UserSearch, Pencil } from 'lucide-react';
import { MandantAktePicker } from './MandantAktePicker';

export const refFromSel = (sel) => (sel?.mandanten_nr ? (sel.akte?.aktenzeichen || sel.mandanten_nr) : '');

// Kanzlei-Upload: in zwei Klicks festlegen, zu welchem Mandanten (und welcher Akte) ein Dokument gehört
export const TeamDokZuordnung = ({ value, onChange, testId = 'dok-zuordnung' }) => {
  const [edit, setEdit] = useState(!value?.mandanten_nr);
  if (value?.mandanten_nr && !edit) {
    return (
      <div className="flex items-center gap-3 p-3 bg-emerald-50 border border-emerald-200 rounded-sm" data-testid={`${testId}-confirmed`}>
        <CheckCircle2 className="w-5 h-5 text-emerald-600 flex-shrink-0" />
        <div className="flex-1 min-w-0 text-sm">
          <p className="text-[10px] tracking-[0.2em] uppercase text-emerald-700">Wird abgelegt bei</p>
          <p className="text-[#1B3A5C] font-medium truncate">{value.name} <span className="font-mono text-xs text-[#34536b]">· M-{value.mandanten_nr}{value.akte?.aktenzeichen ? ` · AZ ${value.akte.aktenzeichen}` : ' · ohne Akte'}</span></p>
        </div>
        <button type="button" onClick={() => setEdit(true)} data-testid={`${testId}-change`} className="inline-flex items-center gap-1 text-[11px] tracking-wider text-[#1B3A5C] hover:text-[#b8893d]"><Pencil className="w-3.5 h-3.5" /> ÄNDERN</button>
      </div>
    );
  }
  return (
    <div className="p-3 border-2 border-[#b8893d]/40 bg-[#fbf7f0] rounded-sm space-y-2" data-testid={testId}>
      <p className="flex items-center gap-2 text-sm font-medium text-[#1B3A5C]"><UserSearch className="w-4 h-4 text-[#b8893d]" /> Für welchen Mandanten ist das Dokument?</p>
      <p className="text-[11px] text-[#34536b]">1. Namen, Nummer, E-Mail oder Aktenzeichen eintippen &nbsp;·&nbsp; 2. Mandant anklicken &nbsp;·&nbsp; 3. optional die Akte wählen</p>
      <MandantAktePicker value={value} onChange={onChange} testId={`${testId}-picker`} />
      {value?.mandanten_nr && (
        <button type="button" onClick={() => setEdit(false)} data-testid={`${testId}-done`} className="w-full py-2 text-[11px] tracking-wider bg-[#1B3A5C] text-white hover:bg-[#b8893d] transition-colors">ÜBERNEHMEN</button>
      )}
    </div>
  );
};

export default TeamDokZuordnung;
